import clsx from 'clsx'
import { CheckCircle, Clock, User } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'

const LoginSuccess: React.FC = () => {
  // const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  // const [countdown, setCountdown] = useState(3)
  
  // 从URL参数获取用户信息
  const userName = searchParams.get('name') || '用户'
  const userDept = searchParams.get('dept') || ''
  
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setCountdown((prev) => {
  //       if (prev <= 1) {
  //         navigate('/warehouse')
  //         return 0
  //       }
  //       return prev - 1
  //     })
  //   }, 1000)

  //   return () => clearInterval(timer)
  // }, [navigate])

  // const handleGoToWorkspace = () => {
  //   navigate('/warehouse')
  // }

  return (
    <div className={clsx('p-8', 'space-y-8')}>
      {/* 成功状态 */}
      <div className={clsx('flex', 'flex-col', 'items-center', 'space-y-4')}>
        <div className={clsx('relative')}>
          <div className={clsx(
            'w-20', 'h-20', 'rounded-full', 'flex', 'items-center', 'justify-center',
            'bg-green-100', 'shadow-sm'
          )}>
            <CheckCircle className={clsx('w-12', 'h-12', 'text-green-600')} />
          </div>
          <div className={clsx(
            'absolute', '-top-2', '-right-2', 'w-8', 'h-8', 'bg-white', 'rounded-full',
            'flex', 'items-center', 'justify-center', 'border-2', 'border-green-100', 'shadow-sm'
          )}>
            <CheckCircle className={clsx('w-5', 'h-5', 'text-green-600')} />
          </div>
        </div>

        <div className={clsx('text-center', 'space-y-2')}>
          <h3 className={clsx('text-xl', 'font-semibold', 'text-gray-800')}>
            登录成功！
          </h3>
          <p className={clsx('text-sm', 'text-gray-600')}>
            欢迎回来，正在为您准备工作台...
          </p>
        </div>
      </div>

      {/* 用户信息 */}
      <div className={clsx('bg-gray-50', 'rounded-xl', 'p-6', 'space-y-4')}>
        <div className={clsx('flex', 'items-center', 'space-x-3')}>
          <div className={clsx(
            'w-10', 'h-10', 'rounded-full', 'bg-blue-100', 
            'flex', 'items-center', 'justify-center'
          )}>
            <User className={clsx('w-5', 'h-5', 'text-blue-600')} />
          </div>
          <div className={clsx('flex-1')}>
            <h4 className={clsx('font-medium', 'text-gray-800')}>
              {userName}
            </h4>
            {userDept && (
              <p className={clsx('text-sm', 'text-gray-600')}>
                {userDept}
              </p>
            )}
          </div>
        </div>
        
        <div className={clsx('flex', 'items-center', 'space-x-3', 'text-sm', 'text-gray-600')}>
          <Clock className={clsx('w-4', 'h-4')} />
          <span>登录时间：{new Date().toLocaleString('zh-CN')}</span>
        </div>
      </div>

      {/* 自动跳转提示 */}
      {/* <div className={clsx('text-center', 'space-y-4')}>
        <div className={clsx('flex', 'items-center', 'justify-center', 'space-x-2', 'text-sm', 'text-gray-600')}>
          <span>{countdown} 秒后自动跳转到工作台</span>
        </div>
        
        <button
          onClick={handleGoToWorkspace}
          className={clsx(
            'w-full', 'bg-blue-600', 'hover:bg-blue-700', 
            'text-white', 'font-medium', 'py-3', 'px-4', 'rounded-xl',
            'flex', 'items-center', 'justify-center', 'space-x-2',
            'transition-colors', 'duration-200'
          )}
        >
          <span>立即进入工作台</span>
          <ArrowRight className={clsx('w-4', 'h-4')} />
        </button>
      </div> */}
    </div>
  )
}

export default LoginSuccess